import {Helpers} from "../helpers/helpers";

export default class ContactsPage {
    private $holder: JQuery;
    private CLINIC = 'clinic';

    private readonly selectors = {
        feedbackFormWrapper: '.js-feedback-form-holder',
        btnToggle: '.js-toggle-item',
    };

    constructor($holder: JQuery) {
        this.$holder = $holder;

        this.init();
    }

    private init(): void {
        if (!this.hasHashParamsUrl()) {
            return;
        }
        const $wrapperForm = this.$holder.find(this.selectors.feedbackFormWrapper);

        if (!$wrapperForm.get(0)) {
            return;
        }

        Helpers.scrollTo($wrapperForm.get(0) as HTMLHtmlElement, 0);

        if (this.checkHref()) {
            this.$holder.find(this.selectors.btnToggle).eq(1).click();
        }
    }

    /**
     * Проверить наличие параметра в url
     * @private
     */
    private checkHref(): boolean
    {
        let url = new URL(location.href);
        const hashParams = url.hash;

        return hashParams.includes(this.CLINIC);
    }

    private hasHashParamsUrl(): boolean {

        let url = new URL(location.href);
        return !!url.hash;
    }
}
